import { useSelector } from "react-redux";
export const useAPI = () => {
  const storeConfigState = useSelector((state) => state.storeSettings);

  /* 
     API END POINT                                                                     FILENAME
    ===============                                                                   ===========
    /ra/submit_return_request/                                                        Bank.jsx,ReturnReview.jsx
    /api/exchange/item/exchange_session/                                              Exchange.jsx
    /api/exchange/item/exchange_session/${exchange_session_pk}/                       Exchange.jsx
    /api/exchange/item/payment_info/                                                  ExchangePayment.jsx
    /api/exchange/item/${selectedProductDetailsState.variantID}/                      ExchangePayment.jsx
    /ra/refund_exchange_payment_status/${paymentSettingsState.paymentID}/             ExchangeSubmitted.jsx
    /accept-incentive/                                                                GetRefund.jsx
    /ra/get_store_config/${shopifyStoreName}                                          Main.jsx
    /common/upload_image/                                                             IncentiveCertificate.jsx,UploadingImg
    /share/social/                                                                    IncentiveCertificate.jsx
    /fetch-incentive/                                                                 Return.jsx                                                            
    /api/exchange/item/                                                               useExchangeFetch.jsx
    /api/exchange/item/get_paginated_exchange_items/                                  useExchangeFetch
    /process-return/                                                                  useFetchItems,functions.js
    */

  /* BASE URL */
  const API_BASE_URL = process.env.REACT_APP_API_URL; //No slash has been added at end

  /* END POINTS */
  const ECORETURNS_API_ENDPOINT = "/ecoreturns";
  const SHOPIFY_ENDPOINT_RA = "/ra";
  const SHOPIFY_ENDPOINT_API = "/api";
  const SHOPIFY_ENDPOINT_COMMON = "/common";
  const SHOPIFY_ENDPOINT_SHARE = "/share";

  /* API LIST */
  let ECORETURNS_ORDER_VALIDATION_API,
    EXCHANGE_SUBMIT_API,
    RETURN_SUBMIT_API; /*Woo COMMERCE */

  let PROCESS_RETURN_API = "/process-return/";
  let FETCH_INCENTIVE_API = "/fetch-incentive/";
  let ACCEPT_INCENTIVE_API = "/accept-incentive/";

  /*api*/
  let EXCHANGE_ITEM_EXCHANGE_SESSION_API = "/exchange/item/exchange_session/";
  let EXCHANGE_ITEM_EXCHANGE_SESSION_PK_API =
    "/exchange/item/exchange_session/"; /*ADD PK VARIABLE*/
  let EXCHANGE_ITEM_PAYMENT_INFO_API = "/exchange/item/payment_info/";
  let EXCHANGE_ITEM_VARIANT_ID_API = "/exchange/item/"; /*ADD VARIANT ID  */
  let EXCHANGE_ITEM_API = "/exchange/item/";
  let EXCHANGE_ITEM_PAGINATED_EXCHANGE_API =
    "/exchange/item/get_paginated_exchange_items/";
  let EXCHANGE_RAZORPAY_PAYMENT_API = "/exchange/item/razorpay_success/";
  let EXCHANGE_PRODUCT_VARIANTS =  "/exchange/item/get_variants/";

  /*ra*/
  let SUBMIT_RETURN_REQUEST_API = "/submit_return_request/";
  let REFUND_EXCHANGE_PAYMENT_STATUS_PAYMENT_ID_API =
    "/refund_exchange_payment_status/"; /*ADD PAYMENT ID */
  let GET_STORE_CONFIG_SHOPIFY_STORE_NAME_API =
    "/get_store_config/"; /*ADD SHOPIFY STORENAME */

  /*share*/
  let SOCIAL_API = "/social/";

  /*common*/
  let UPLOAD_IMAGE_API = "/upload_image/";

  let CHATGPT_API = "/chatgpt/";
  let GET_RETURN_PAYMENT_INFO = "/get_return_payment_info/";

  ECORETURNS_ORDER_VALIDATION_API = `${API_BASE_URL}${ECORETURNS_API_ENDPOINT}/validate/`; /*process return */

  if (storeConfigState?.platform === "shopify") {
    PROCESS_RETURN_API = `${API_BASE_URL}${PROCESS_RETURN_API}`;
    ACCEPT_INCENTIVE_API = `${API_BASE_URL}${ACCEPT_INCENTIVE_API}`;
    FETCH_INCENTIVE_API = `${API_BASE_URL}${FETCH_INCENTIVE_API}`;

    /*api*/
    EXCHANGE_ITEM_EXCHANGE_SESSION_API = `${API_BASE_URL}${SHOPIFY_ENDPOINT_API}${EXCHANGE_ITEM_EXCHANGE_SESSION_API}`;
    EXCHANGE_ITEM_EXCHANGE_SESSION_PK_API = `${API_BASE_URL}${SHOPIFY_ENDPOINT_API}${EXCHANGE_ITEM_EXCHANGE_SESSION_PK_API}`;
    EXCHANGE_ITEM_PAYMENT_INFO_API = `${API_BASE_URL}${SHOPIFY_ENDPOINT_API}${EXCHANGE_ITEM_PAYMENT_INFO_API}`;
    EXCHANGE_ITEM_VARIANT_ID_API = `${API_BASE_URL}${SHOPIFY_ENDPOINT_API}${EXCHANGE_ITEM_VARIANT_ID_API}`;
    EXCHANGE_ITEM_API = `${API_BASE_URL}${SHOPIFY_ENDPOINT_API}${EXCHANGE_ITEM_API}`;
    EXCHANGE_PRODUCT_VARIANTS = `${API_BASE_URL}${SHOPIFY_ENDPOINT_API}${EXCHANGE_PRODUCT_VARIANTS}`;
    EXCHANGE_ITEM_PAGINATED_EXCHANGE_API = `${API_BASE_URL}${SHOPIFY_ENDPOINT_API}${EXCHANGE_ITEM_PAGINATED_EXCHANGE_API}`;
    // EXCHANGE_RAZORPAY_PAYMENT_API = `${API_BASE_URL}${SHOPIFY_ENDPOINT_API}${EXCHANGE_RAZORPAY_PAYMENT_API}`;
    /*ra*/
    SUBMIT_RETURN_REQUEST_API = `${API_BASE_URL}${SHOPIFY_ENDPOINT_RA}${SUBMIT_RETURN_REQUEST_API}`;
    REFUND_EXCHANGE_PAYMENT_STATUS_PAYMENT_ID_API = `${API_BASE_URL}${SHOPIFY_ENDPOINT_RA}${REFUND_EXCHANGE_PAYMENT_STATUS_PAYMENT_ID_API}`;
  } else {
    FETCH_INCENTIVE_API = `${API_BASE_URL}${ECORETURNS_API_ENDPOINT}/incentive/fetch/`;
    ACCEPT_INCENTIVE_API = `${API_BASE_URL}${ECORETURNS_API_ENDPOINT}/incentive/accept/`;
    EXCHANGE_ITEM_API = `${API_BASE_URL}${ECORETURNS_API_ENDPOINT}/exchange/items/`;
    EXCHANGE_PRODUCT_VARIANTS = `${API_BASE_URL}${ECORETURNS_API_ENDPOINT}/exchange/item/get_variants/`;
    EXCHANGE_ITEM_PAGINATED_EXCHANGE_API = `${API_BASE_URL}${ECORETURNS_API_ENDPOINT}/exchange/items/next/`;
    EXCHANGE_ITEM_PAYMENT_INFO_API = `${API_BASE_URL}${ECORETURNS_API_ENDPOINT}/exchange/payment/`;
    EXCHANGE_SUBMIT_API = `${API_BASE_URL}${ECORETURNS_API_ENDPOINT}/exchange/submit/`;
    RETURN_SUBMIT_API = `${API_BASE_URL}${ECORETURNS_API_ENDPOINT}/return/submit/`;
    REFUND_EXCHANGE_PAYMENT_STATUS_PAYMENT_ID_API = `${API_BASE_URL}${ECORETURNS_API_ENDPOINT}/refund/credit/`;
  }

  /* COMMON API called in both the platform */

  GET_STORE_CONFIG_SHOPIFY_STORE_NAME_API = `${API_BASE_URL}${SHOPIFY_ENDPOINT_RA}${GET_STORE_CONFIG_SHOPIFY_STORE_NAME_API}`;
  /*social*/
  SOCIAL_API = `${API_BASE_URL}${SHOPIFY_ENDPOINT_SHARE}${SOCIAL_API}`;
  /*common*/
  UPLOAD_IMAGE_API = `${API_BASE_URL}${SHOPIFY_ENDPOINT_COMMON}${UPLOAD_IMAGE_API}`;
  const CHATGPT_INITIAL_API = `${API_BASE_URL}${CHATGPT_API}chat/`;
  const CHATGPT_CHAT_ADD_API = `${API_BASE_URL}${CHATGPT_API}chat/add`;
  const CHATGPT_IMAGE_UPLOAD_API = `${API_BASE_URL}${CHATGPT_API}chat/image/upload`;

  GET_RETURN_PAYMENT_INFO = `${API_BASE_URL}${SHOPIFY_ENDPOINT_RA}${GET_RETURN_PAYMENT_INFO}`;
  EXCHANGE_RAZORPAY_PAYMENT_API = `${API_BASE_URL}${SHOPIFY_ENDPOINT_API}${EXCHANGE_RAZORPAY_PAYMENT_API}`;
  return {
    ECORETURNS_ORDER_VALIDATION_API,
    EXCHANGE_SUBMIT_API,
    RETURN_SUBMIT_API,
    PROCESS_RETURN_API,
    FETCH_INCENTIVE_API,
    ACCEPT_INCENTIVE_API,
    EXCHANGE_ITEM_EXCHANGE_SESSION_API,
    EXCHANGE_ITEM_EXCHANGE_SESSION_PK_API,
    EXCHANGE_ITEM_PAYMENT_INFO_API,
    EXCHANGE_ITEM_VARIANT_ID_API,
    EXCHANGE_ITEM_API,
    EXCHANGE_PRODUCT_VARIANTS,
    EXCHANGE_ITEM_PAGINATED_EXCHANGE_API,
    SUBMIT_RETURN_REQUEST_API,
    REFUND_EXCHANGE_PAYMENT_STATUS_PAYMENT_ID_API,
    GET_STORE_CONFIG_SHOPIFY_STORE_NAME_API,
    SOCIAL_API,
    UPLOAD_IMAGE_API,
    CHATGPT_INITIAL_API,
    CHATGPT_CHAT_ADD_API,
    CHATGPT_IMAGE_UPLOAD_API,
    GET_RETURN_PAYMENT_INFO,
    EXCHANGE_RAZORPAY_PAYMENT_API,
  };
};
